/**
 * @flow
 * @relayHash 53cf0933bd100a4c5b120cb9a86f6b2a
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AdoptedSystemDocumentTemplatesQueryVariables = {|
  sort?: ?string
|};
export type AdoptedSystemDocumentTemplatesQueryResponse = {|
  +adoptedSystemDocumentTemplates: ?{|
    +adoptedSystemDocumentTemplates: ?{|
      +totalCount: ?number,
      +edges: $ReadOnlyArray<?{|
        +node: ?{|
          +pk: ?number,
          +name: ?string,
          +total: ?number,
          +adopted: ?number,
        |}
      |}>,
    |},
    +error: ?{|
      +statusCode: ?number
    |},
  |}
|};
export type AdoptedSystemDocumentTemplatesQuery = {|
  variables: AdoptedSystemDocumentTemplatesQueryVariables,
  response: AdoptedSystemDocumentTemplatesQueryResponse,
|};
*/


/*
query AdoptedSystemDocumentTemplatesQuery(
  $sort: String
) {
  adoptedSystemDocumentTemplates(sort: $sort) {
    adoptedSystemDocumentTemplates {
      totalCount
      edges {
        node {
          pk
          name
          total
          adopted
        }
      }
    }
    error {
      statusCode
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "sort",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "adoptedSystemDocumentTemplates",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "sort",
        "variableName": "sort",
        "type": "String"
      }
    ],
    "concreteType": "AdoptedSystemDocumentTemplateListType",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "adoptedSystemDocumentTemplates",
        "storageKey": null,
        "args": null,
        "concreteType": "AdoptedSystemDocumentTemplatesConnection",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "totalCount",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "AdoptedSystemDocumentTemplatesEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "AdoptedSystemDocumentTemplateType",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "pk",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "total",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "adopted",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "error",
        "storageKey": null,
        "args": null,
        "concreteType": "ErrorType",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "statusCode",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "AdoptedSystemDocumentTemplatesQuery",
  "id": "c076dc5da33507c93efb20ca32307f43",
  "text": null,
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "AdoptedSystemDocumentTemplatesQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "AdoptedSystemDocumentTemplatesQuery",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
node.text = "query AdoptedSystemDocumentTemplatesQuery(\n  $sort: String\n) {\n  adoptedSystemDocumentTemplates(sort: $sort) {\n    adoptedSystemDocumentTemplates {\n      totalCount\n      edges {\n        node {\n          pk\n          name\n          total\n          adopted\n        }\n      }\n    }\n    error {\n      statusCode\n    }\n  }\n}\n";
(node/*: any*/).hash = 'a641f7b67c4c38c374aaa94937eb5e38';
module.exports = node;
